    PrintCountChart = (function () {
    'use strict';
    var PrintCountChart = function (container) {
        this.container = container;
        this.data = null;
    };

    PrintCountChart.prototype.setData = function (data) {
        this.data = this.transformData(data);
        this.renderChart();
    };

    PrintCountChart.prototype.transformData = function (data) {
        return this.fillWithZero(_.chain(data)
            .countBy(function (item) {
                return moment(item.time).format("YYYY-MM-DD");
            })
            .toPairs()
            .sortBy(function (pair) {
                return moment(pair[0]).format("YYYYMMDD");
            })
            .value());
    };

    /**
     * Takes a sorted data array and fills missing dates
     */
    PrintCountChart.prototype.fillWithZero = function (data) {
        var i = 0;
        var filled_data = [];
        var current_day = moment(data[0][0]);
        while (i < data.length) {
            if (current_day.isBefore(data[i][0])) {
                filled_data.push([current_day.format("YYYY-MM-DD"), 0]);
            } else {
                filled_data.push([current_day.format("YYYY-MM-DD"), data[i][1]]);
                i++;
            }
            current_day = current_day.add('1', 'd');
        }
        return filled_data;
    };

    PrintCountChart.prototype.renderChart = function (data) {
        Plotly.newPlot(this.container, [{
            x: _.map(this.data, function (item) {
                return item[0];
            }),
            y: _.map(this.data, function (item) {
                return item[1];
            }),
            type: 'scatter',

            line: {
                shape: 'spline'
            },
        }], {
            title: 'Anzahl Drucke im Zeitraum',
            xaxis: {
                type: 'date'
            },
            yaxis: {
                rangemode: 'tozero'
            }
        });
    };

    PrintCountChart.prototype.clearChart = function (data) {
        Plotly.purge(this.container)
    };
    return PrintCountChart;

})();

